import React, { useState, useEffect } from "react";
import LevelCardPNG from "../../assets/images/level-c.png";
import CompletedLevelCardPNG from "../../assets/images/completed_level_g.png";
import PlayButtonPNG from "../../assets/images/play-btn.png";
import useFetchLevels from "../../hooks/useFetchLevels";
import { CampLoader } from "../../components/loader";
import { useAuth } from "../../context/AuthContext";
import { playSpeech, playSpeechTTS } from "../../utils/playSpeech";
import { playSpeechKokoro } from "../../utils/playSpeechKokoro";
import { stopSpeechKokoro } from "../../utils/playSpeechKokoro";
import { ChevronLeft, ChevronRight } from "lucide-react";
import levelButtonSound from "../../assets/audios/level.wav";

import "./style.css";

function LevelsPage({ handleClick }) {
  const [levels, loading, subjectName] = useFetchLevels();
  const { setCommonWarning, setCommonError, selectedLang } = useAuth();

  const [showLoader, setShowLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1536,
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardsPerPage = windowWidth >= 1004 ? 8 : 4;

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 0);
    return () => clearTimeout(timer);
  }, []);

  const stopSpeech = () => {
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
    // If you're using audio elements, you may need to stop those too
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
  };

  // Calculate pagination
  const totalPages = Math.ceil(levels.length / cardsPerPage);
  const startIndex = currentPage * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const currentLevels = levels.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    stopSpeech();
    stopSpeechKokoro();

    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNextPage = () => {
    stopSpeech();
    stopSpeechKokoro();

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  const handlePlayClick = (level) => {
    stopSpeech();
    stopSpeechKokoro();

    if (!level.is_purchased) {
      setCommonWarning("Please purchase this level to proceed.");
    } else {
      handleClick(level.id, level.name, `/topics`);
    }
  };
  const [hasPlayed, setHasPlayed] = useState(false);
  const levelSpeechPlayed =
    localStorage.getItem("levelSpeechPlayed") === "true";
  useEffect(() => {
    if (loading) return;

    playSpeechKokoro(
      `Your ${subjectName} journey starts now! Pick a path to begin!`,
    );
  }, [loading, subjectName]);

  useEffect(() => {
    return () => {
      stopSpeechKokoro();
    };
  }, []);
  // useEffect(() => {
  //   if (!loading && !hasPlayed) {
  //     playSpeechTTS(
  //       `Your ${subjectName} journey starts now! Pick a path to begin!`,
  //       setCommonError
  //     );
  //     setHasPlayed(true);
  //     localStorage.setItem("levelSpeechPlayed", "true");
  //   }
  // }, [loading, hasPlayed, subjectName, playSpeechTTS]);
  // console.log("Selected Language in LevelsPage:", selectedLang);
  // console.log("Selected Language in LevelsPage:", selectedLang?.code);
  const buttonAudio = new Audio(levelButtonSound);

  return (
    <div className="levels-content-box">
      <div className="welc-text">
        <h2 className="level-text">Explore to Genius!</h2>
      </div>

      <div className="journey-level">
        <div
          className={`journey-wrapper ${
            selectedLang?.code !== "en" ? "j-lang" : ""
          }`}
        >
          <div
            className={`journey-text ${
              selectedLang?.code !== "en" ? "lang-changed" : ""
            }`}
          >
            Your{" "}
            <span
              className={`sub-name ${
                selectedLang?.code !== "en" ? "lang-changed" : ""
              }`}
            >
              {subjectName}
            </span>{" "}
            journey starts now! <br />
            Pick a path to begin!
          </div>
        </div>

        <div className="levels-section-wrapper">
          <div className="levels-section">
            {loading || showLoader ? (
              <CampLoader />
            ) : (
              currentLevels.map((level, index) => {
                return (
                  <div className="level-card" key={index}>
                    <div className="level-container">
                      <img
                        src={
                          level.percentage === 100
                            ? CompletedLevelCardPNG
                            : LevelCardPNG
                        }
                        alt="level card"
                        className={`level-card-img${
                          level.percentage === 100
                            ? " completed"
                            : level.percentage < 100 && level.percentage > 0
                              ? " in-progress"
                              : ""
                        }`}
                      />
                      <div
                        className={`levels-text ${
                          selectedLang?.code !== "en" ? "lang-changed" : ""
                        } ${
                          level.percentage === 100
                            ? "completed"
                            : level.percentage < 100 && level.percentage > 0
                              ? " in-progress"
                              : ""
                        }`}
                      >
                        {level.name}
                      </div>
                      {level.percentage > 0 && level.percentage < 100 && (
                        <div
                          className={`levels-progress-bar
                        ${selectedLang?.code !== "en" ? "lang-changed" : ""}
                        ${
                          level.percentage === 100
                            ? "completed"
                            : level.percentage < 100 && level.percentage > 0
                              ? "in-progress"
                              : ""
                        }
                      `}
                        >
                          <div
                            className="levels-progress-fill"
                            style={{ width: `${level.percentage}%` }}
                          ></div>
                        </div>
                      )}
                      <div
                        className={`play-button
                        ${selectedLang?.code !== "en" ? "lang-changed" : ""}
                        ${
                          level.percentage === 100
                            ? "completed"
                            : level.percentage < 100 && level.percentage > 0
                              ? "in-progress"
                              : ""
                        }
                      `}
                      >
                        <img
                          onClick={(e) => {
                            buttonAudio
                              .play()
                              .catch((err) =>
                                console.error("Audio play failed:", err),
                              );
                            handlePlayClick(level);
                          }}
                          src={PlayButtonPNG}
                          alt="Play Button"
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* Pagination Controls */}
      {!loading && !showLoader && totalPages > 1 && (
        <>
          <div className="carousel-nav">
            <button
              className="carousel-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
            >
              <ChevronLeft size={30} />
            </button>
            <button
              className="carousel-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <ChevronRight size={30} />
            </button>
          </div>
          <div className="carousel-info">
            Page {currentPage + 1} of {totalPages}
          </div>
        </>
      )}
    </div>
  );
}

export default LevelsPage;
